<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_titleBack enjoy">
      <div class="attach_subtitle">
        <h1>파운틴 라운지</h1>
        <p>파운틴Ⅳ, Ⅴ 회원만을 위한 특별한 공간</p>
      </div>
    </div><!--rew19_titleBack -->


    <div class="rew19_contents_inner">
      <h3 class="rew19_titleVip">파운틴 라운지 이벤트</h3>
        <ul class="rew19_imageback_list">
          <li v-for="(item) in viewData.vipList" v-bind:key="item.event_id" v-bind:style="{ backgroundImage: 'url(' + item.img_url + ')' }">
            <a href="javascript:;" @click="onClickMoveFountainEvent(item.event_id)">
              <div class="addtional">
                <span class="positionChk">
                  <span v-if="item.isEndEvent" class="rew18_goodsDim">
                    <em>종료된 이벤트 입니다.</em>
                  </span>
                  <img :src="item.img_url" alt="" title=""
                    onerror="this.src='https://resource2018.nuskinkorea.co.kr/images/renew/product_img_empty.jpg'"
                  />
                  <span class="title">{{item.banner_subject}}</span>
                </span>
                <span class="date">{{item.start_date}} ~ {{item.end_date}}</span>
                <span class="caption"><em>{{item.subject}}</em></span>
              </div>
            </a>
          </li>
        </ul>
    </div><!--rew19_contents_inner-->
  </div><!--rew19_aro_wrap-->
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as ErrMsg from "@/utils/error_msg";
export default {
  name: "vipList",
  extends: AroBase,
  computed: {
    isNuskinChannel: function() {
      return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    },
    isMeCommerceChannel : function(){
      return this.$aroChannel == Const.ARO_CHANNEL_ME_COMMERCE;
    }
  },
  props: {
  },
  data: () => ({
    //View Data
    viewData : {
      memberShip :{
        // aroBuyCount: 11
        // buyPeriod: "11",
        // couponCount: "0",
        // dueDate: "2019-10-01",
        gradeCode: "0",
        // gradeName: "파운틴Ⅱ",
        // isUseAro: "Y",
        // message: "조회성공",
        // nextGradeCode: "2",
        // nextGradeName: "파운틴Ⅲ",
        // startDate: "2019-04-30",
        // status: "0000",
        // vipDueDate: "2020-04-01",
        couponCount: 0,
      },
      vipList:{},
    },
  }),
  created() {
    let _this = this;
  },
  mounted() {
    let _this = this;

    _this.initUI();

    _this.loadData();
  },
  methods: {
    /**
     * JQuery UI
     */
    initUI : function(){

    },

    /**
     * API Request
     */
    //멤버쉽 정보 가져오기
    apiGetMemberShips : function(){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/memberships`, {
        params: {}
      });
    },

    //파운틴 라운지 목록 가져오기
    apiVipList : function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/vipList`, {
        params: {}
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadData : function(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetMemberShips().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          //success

          _this.viewData = {
            ..._this.viewData,
            memberShip : {...res.data}
          };

        }else{
          //Fail
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

        if(!("3" == _this.viewData.memberShip.gradeCode || "4" ==_this.viewData.memberShip.gradeCode)){
          let errMsg = "파운틴 라운지는 enJoy 멤버십 파운틴 IV, V 이상 회원만 입장할 수 있습니다.";
          _this.$dialogs.alert(errMsg)
          .then(res => {
            location.href="/app/ro/aroShop/memberShip";
          });
        }else{
          _this.getVipList();
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    onClickMoveFountainEvent(event_id) {
      let _this = this;

      if (181 === event_id) {
        //let outLinkUrl = "https://nuskinevent.com/2020/enjoy/reward.html";
        let outLinkUrl = "https://nuskinevent.com/2021/25years/event.html";

        if ("string" === typeof mIsMobileApplication && "true" === mIsMobileApplication) {
          try {
            if ("object" === typeof mMobileCommon) {
              mMobileCommon.sendMessageToApp("goWebBrowserFromServer", outLinkUrl);
            }

          } catch (e) {

          }

        } else {
          window.location.href = outLinkUrl;
        }

      } else {
        let targetUrl = '/app/ro/promotion/fountainEvent?event_id=' + event_id;
        window.location.href = targetUrl;
      }
    },

    getVipList(){
      let _this = this;

      _this.apiVipList().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          //success

          _this.viewData = {
              ..._this.viewData,
              vipList : {...res.data.list}
            };

          let vipList = res.data.list;
          _this.viewData.vipList = vipList.filter(item => {
            if(item.isStartEvent)
              return item;
          });

        }else{
          //Fail
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    }
  }
}
</script>
<style>
.enjoyEvent .rew18_goodsDim em{
  font-size: 30px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/my/njoy/vipList.vue